import {
  person10,
  person11,
  person12,
  person13,
  person14,
  person15,
  person6,
  person7,
  person8,
  person9,
} from "../assets/image";
import { REVIEW } from "../type";

export const Reviews: REVIEW[] = [
  {
    person: {
      avatar: person6,
      name: "Sarah Bennett",
      pos: "Lead Developer, TechNova Solutions",
    },
    comment:
      "Codeblaze revolutionized our development process. Tasks that used to take days now only take hours. The platform’s AI capabilities are unparalleled.",
  },
  {
    person: {
      avatar: person7,
      name: "Jason Lee",
      pos: "Founder, Startify Ventures",
    },
    comment:
      "As a non-technical founder, Codeblaze empowered me to build a fully functional web app without needing a developer. It’s a game-changer for startups.",
  },
  {
    person: {
      avatar: person9,
      name: "Priya Malhotra",
      pos: "CTO, BrightHive Inc.",
    },
    comment:
      "With Codeblaze, we’ve reduced development time by over 80%. The automated code generation is clean, efficient, and scalable.",
  },
  {
    person: {
      avatar: person8,
      name: "Michael Tanaka",
      pos: "Senior Engineer, CloudX Systems",
    },
    comment:
      "The ability to use text prompts and generate full-stack applications is incredible. Codeblaze is by far the most efficient tool I’ve used.",
  },
  {
    person: {
      avatar: person11,
      name: "Emma Johnson",
      pos: "CEO, GreenByte AI",
    },
    comment:
      "Codeblaze saved us thousands of dollars in development costs. It’s intuitive, reliable, and delivers exactly what we need.",
  },
  {
    person: {
      avatar: person10,
      name: "Ahmed Khan",
      pos: "Project Manager, DigitOps",
    },
    comment:
      "Our team has adopted Codeblaze across all projects, and productivity has soared. The AI ensures we deliver high-quality results faster",
  },
  {
    person: {
      avatar: person13,
      name: "Linda Spencer",
      pos: "Product Owner, EdgeLogic",
    },
    comment:
      "The flexibility of supporting over 50 programming languages makes Codeblaze a versatile solution for any team. It’s a must-have!",
  },
  {
    person: {
      avatar: person12,
      name: "Carlos Ramirez",
      pos: "Co-Founder, InnovateLabs",
    },
    comment:
      "Codeblaze handled complex app development with ease. The time savings alone make it an essential tool for any business.",
  },
  {
    person: {
      avatar: person14,
      name: "Meera Patel",
      pos: "Software Consultant, DevSphere",
    },
    comment:
      "I’ve seen many platforms claim to save time, but Codeblaze delivers on its promise. It’s become an indispensable part of my workflow.",
  },
  {
    person: {
      avatar: person12,
      name: "Tom Edwards",
      pos: "Head of IT, BrightCore Solutions",
    },
    comment:
      "The AI-driven debugging and efficiency of Codeblaze have completely transformed how we approach development. Highly recommend it!",
  },
  {
    person: {
      avatar: person15,
      name: "Anna Wills",
      pos: "Freelance Web Developer",
    },
    comment:
      "Codeblaze’s voice-to-code feature is a lifesaver. It speeds up development and lets me focus on design and functionality.",
  },
  {
    person: {
      avatar: person8,
      name: "Daniel Choi",
      pos: "Founder, ScaleOps AI",
    },
    comment:
      "Codeblaze combines simplicity with power. It’s the perfect solution for startups and enterprises looking to innovate quickly.",
  },
];
